export const DEFAULT_META_TITLE = 'expondo';
